import React from 'react';
import { QuestRoute } from '../../../api/QuestRoutes';
import { formatCurrency, generateId, shortHandDateTime } from '../../../utility/functions';
import Table from '../../../table/Table';
import LinkTo from '../../../forms/LinkTo';


const AirPayTransactions = ({ ...props }) => {

    const tableConfig = {
        endpoint: QuestRoute.reports.mobile.airPay,
        isReport: true,
        headers: [
            {
                label: 'ID',
                propKey: 'resultId',
            }, {
                label: 'Location',
                propKey: 'locationName',
                options: true
            }, {
                label: 'Date',
                propKey: 'kioskDateTime',
            }, {
                label: 'Name',
                propKey: 'name',
            }, {
                label: 'Email',
                propKey: 'email',
            }, {
                label: 'Transaction Type',
                propKey: 'transType',
                options: true,
                show: false
            }, {
                label: 'Amount',
                propKey: 'amount',
                type: 'number'
            }, {
                label: 'Approved',
                propKey: 'approved',
                options: true,
                show: false
            }, {
                label: 'Card Type',
                propKey: 'cardType',
                options: true
            }, {
                label: 'Card Number',
                propKey: 'cardNumber',
            },
        ],
        // quickSort: [
        //     {
        //         label: 'Single Washes',
        //         propKey: 'codeType',
        //         query: 'Single Wash',
        //         color: '#8cce44',
        //     }, {
        //         label: 'Bundles',
        //         propKey: 'codeType',
        //         query: 'Wash Bundle',
        //         color: '#3890fe',
        //     },
        // ],
        sticker: [
            {
                label: 'Number of Transactions',
                color: '#21D59B',
                callback: (data) => data.length
            }, {
                label: 'Total Revenue',
                color: '#21D59B',
                callback: (data) => {
                    return formatCurrency(data.reduce((a, b) => b.amount + a, 0) || 0)
                }
            },
        ],
        renderFormat: (e) => ({
            row: (
                <tr key={generateId()}>
                    <td>{e.resultId}</td>
                    <td>{e.locationName}</td>
                    <td>{shortHandDateTime(e.kioskDateTime)}</td>
                    <td>
                        <LinkTo customerId={e.appUserId}>{e.name}</LinkTo>
                    </td>
                    <td>{e.email}</td>
                    <td>{e.transType}</td>
                    <td>{formatCurrency(e.amount)}</td>
                    <td>{e.approved ? 'Yes' : 'No'}</td>
                    <td>{e.cardType}</td>
                    <td>{e.cardNumber}</td>
                </tr>
            ),
            children: (
                <Table
                    config={{
                        compact: true,
                        disableTableControls: true,
                        disableHeaderSearch: true,
                        data: [e],
                        headers: [
                            {
                                label: 'Processor Code',
                            }, {
                                label: 'Processor Message',
                            }, {
                                label: 'Bank Code',
                            }, {
                                label: 'Bank Message',
                            }, {
                                label: 'Auth Number',
                            }, {
                                label: 'MAC Address',
                            }, {
                                label: 'Model',
                            }, {
                                label: 'Version',
                            }, {
                                label: 'Terminal ID',
                            }, {
                                label: 'Date',
                            }, {
                                label: 'Pre-Auth ID',
                            }, {
                                label: 'Record ID',
                            },
                        ],
                        renderFormat: () => (
                            <tr key={generateId()}>
                                <td>{e.processorCode}</td>
                                <td>{e.processorMessage}</td>
                                <td>{e.bankCode}</td>
                                <td>{e.approved ? 'Approved' : 'Declined'}</td>
                                <td>{e.authNumber}</td>
                                <td>{e.macAddress}</td>
                                <td>{e.model}</td>
                                <td>{e.version}</td>
                                <td>{e.terminalId}</td>
                                <td>{shortHandDateTime(e.kioskDateTime)}</td>
                                <td>{e.processorMessage}</td>
                                <td>{e.transRecordId}</td>
                            </tr>
                        )
                    }}
                />
            )
        })
    }

    return (
        <Table config={tableConfig} />
    );
}

export default AirPayTransactions;